import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { copyToClipBoard } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';

export default function CopyToClipBoard(props) {
  const { text } = props;

  const copyText = (e, text) => {
    e.stopPropagation();
    copyToClipBoard(text);
  };
  // hw-tooltip hw-bottom-left
  return (
    <div
      className="hw-tooltip hw-bottom-left copy-to-clipboard"
      title={text}
      data-tooltip={'Copy to Clipboard'}
      onClick={e => copyText(e, text)}
    >
      {text}
    </div>
  );
}
CopyToClipBoard.propTypes = {
  text: PropTypes.string,
};
CopyToClipBoard.defaultProps = {
  text: '',
};
